<p-table [value]="this.patientsMetadata" responsiveLayout="scroll">
  <ng-template pTemplate="header">
    <tr>
      <th>{{ "COMMON.ACTIONS" | translate }}</th>
      <th>{{ "COMMON.METADATA.TYPE" | translate }}</th>
      <th>{{ "COMMON.METADATA.NAME" | translate }}</th>
      <th>{{ "COMMON.METADATA.DEFAULT" | translate }}</th>
      <th>{{ "COMMON.METADATA.OPTIONS" | translate }}</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-metadata>
    <tr>
      <td>
        <app-delete-button-metadata-patients
          [payload]="metadata"
          [onDelete]="this.onDelete"
        >
        </app-delete-button-metadata-patients>
      </td>
      <td>
        {{ "COMMON.METADATA." + metadata.metadata_type.name | translate }}
      </td>
      <td>{{ metadata.name }}</td>
      <td>{{ metadata.default }}</td>
      <td>{{ metadata.options.length }}</td>
    </tr>
  </ng-template>
</p-table>
